import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const TambahUser = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [tipeUser, setTipeUser] = useState("DEVELOPER");
  const [aksesKategori, setAksesKategori] = useState(false);
  const [aksesDaftarUser, setAksesDaftarUser] = useState(false);
  const [aksesMerk, setAksesMerk] = useState(false);
  const [aksesBarang, setAksesBarang] = useState(false);
  const [aksesAdminWhatsapp, setAksesAdminWhatsapp] = useState(false);
  const [aksesInformasiToko, setAksesInformasiToko] = useState(false);
  const [aksesKeranjang, setAksesKeranjang] = useState(false);
  const [aksesPesanan, setAksesPesanan] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const saveUser = async (event) => {
    event.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError("Username dan password wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      const duplicate = await axios.post(`${tempUrl}/getUsername`, {
        username,
        _id: user.id,
        token: user.token,
      });
      if (duplicate.data.length > 0) {
        setError("Username sudah digunakan.");
        setLoading(false);
        return;
      }

      await axios.post(`${tempUrl}/auth/register`, {
        username,
        password,
        tipeUser,
        akses: {
          kategori: aksesKategori,
          daftarUser: aksesDaftarUser,
          merk: aksesMerk,
          barang: aksesBarang,
          adminWhatsapp: aksesAdminWhatsapp,
          informasiToko: aksesInformasiToko,
          keranjang: aksesKeranjang,
          pesanan: aksesPesanan,
        },
        _id: user.id,
        token: user.token,
      });
      navigate("/daftarUser");
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menyimpan user.");
    }
    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">User</div>
          <h1 className="page-title">Tambah User</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveUser}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Username</Form.Label>
                <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Tipe User</Form.Label>
                <Form.Select
                  value={tipeUser}
                  onChange={(e) => setTipeUser(e.target.value)}
                >
                  <option value="DEVELOPER">DEVELOPER</option>
                  <option value="MANAGER">MANAGER</option>
                  <option value="ADMIN">ADMIN</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <h2 className="h6 fw-bold mt-4 mb-2">Hak Akses</h2>
          <div className="access-menu-groups">
            <div className="access-menu-group">
              <div className="access-menu-title">Master</div>
              <Form.Check
                type="checkbox"
                label="Kategori"
                checked={aksesKategori}
                onChange={() => setAksesKategori(!aksesKategori)}
              />
              <Form.Check
                type="checkbox"
                label="Merk"
                checked={aksesMerk}
                onChange={() => setAksesMerk(!aksesMerk)}
              />
              <Form.Check
                type="checkbox"
                label="Barang"
                checked={aksesBarang}
                onChange={() => setAksesBarang(!aksesBarang)}
              />
              <Form.Check
                type="checkbox"
                label="WA Admin"
                checked={aksesAdminWhatsapp}
                onChange={() => setAksesAdminWhatsapp(!aksesAdminWhatsapp)}
              />
              <Form.Check
                type="checkbox"
                label="Informasi Toko"
                checked={aksesInformasiToko}
                onChange={() => setAksesInformasiToko(!aksesInformasiToko)}
              />
            </div>
            <div className="access-menu-group">
              <div className="access-menu-title">Transaksi</div>
              <Form.Check
                type="checkbox"
                label="Keranjang"
                checked={aksesKeranjang}
                onChange={() => setAksesKeranjang(!aksesKeranjang)}
              />
              <Form.Check
                type="checkbox"
                label="Pesanan"
                checked={aksesPesanan}
                onChange={() => setAksesPesanan(!aksesPesanan)}
              />
            </div>
            <div className="access-menu-group">
              <div className="access-menu-title">Utility</div>
              <Form.Check
                type="checkbox"
                label="Daftar User"
                checked={aksesDaftarUser}
                onChange={() => setAksesDaftarUser(!aksesDaftarUser)}
              />
            </div>
          </div>
          <div className="form-actions mt-3">
            <Button className="btn-back" type="button" variant="outline-secondary" onClick={() => navigate("/daftarUser")}>
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TambahUser;
